<template>
  <div class="row">
    <div class="col-6">
      <label>Kuwertura</label>
      <v-select
        label="name"
        :options="couverturesOnShelf"
        v-model="couverture.couverture"
        @search="GetCouverturesOnShelf"
      >
        <template slot="no-options"> Podaj część nazwy kuwertury </template>
      </v-select>

      <div
        class="alert alert-danger"
        role="alert"
        v-if="!couverture.couverture"
      >
        Wybierz kuwerturę
      </div>
    </div>

    <div class="col-5">
      <label>Ilość(kg) dodanej kuwertury</label>
      <input
        type="number"
        class="form-control"
        step="0.001"
        v-model="weightSetter"
      />

      <div class="alert alert-danger" role="alert" v-if="errors.weight">
        Wpisana waga przekracza wagę kuwertury lub jest nie prawidłowa
      </div>
    </div>
    <div class="col-1 buttons-col-area">
      <button
        type="button"
        class="btn btn-primary button-col"
        @click="RemoveItem"
      >
        Usuń
      </button>
    </div>
  </div>
</template>

<script>
import CouvertureService from "../../services/couverture.service";

export default {
  components: {},
  props: ["couverture"],
  mixins: [],
  computed: {},
  watch: {
    weightSetter(weight) {
      this.errors.weight = false;
      if (this.couverture.couverture) {
        if (weight > this.couverture.couverture.totalWeight || weight < 0) {
          this.errors.weight = true;
        }
        this.couverture.weight = parseFloat(weight);
      }
    },
    isValid() {
      this.isValid = !this.errors.weight && !this.errors.couverture;
    },
  },
  data() {
    return {
      couverturesOnShelf: undefined,
      weightSetter: 0,
      isValid: true,
      errors: {
        weight: false,
        couverture: false,
      },
    };
  },
  methods: {
    GetCouverturesOnShelf(name) {
      var that = this;
      if (name.length >= 2) {
        CouvertureService.getCouverturesOnShelf(name)
          .then(function (res) {
            that.couverturesOnShelf = res.data;
          })
          .catch(function (e) {
            console.log(e);
          });
      }
    },
    RemoveItem() {
      this.$emit("AddExistingCouvertureRemoveItem", this.couverture.id);
    },
    changeItemOnList(item) {
      this.errors.couverture = !item;
    },
  },
};
</script>